import { Instagram, Facebook } from "lucide-react";
import { site } from "../data/site";

const TikTok = ({ size = 18, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    {...props}
  >
    <path d="M16.5 3c.3 2.1 1.6 3.6 3.5 3.9v2.6c-1.4.1-2.7-.3-3.9-1.1v5.9c0 3.4-2.5 5.7-5.6 5.7-3 0-5.4-2.2-5.4-5.2 0-3.1 2.6-5.3 5.9-5v2.7c-.4-.1-.8-.2-1.2-.2-1.5 0-2.6 1-2.6 2.5 0 1.5 1.1 2.6 2.6 2.6 1.6 0 2.6-1.1 2.6-3.1V3h3.6Z" />
  </svg>
);

const iconMap = { instagram: Instagram, facebook: Facebook, tiktok: TikTok };

export const SocialLinks = ({ variant = "dark", iconSize = 18, className = "" }) => {
  const styles =
    variant === "dark"
      ? "border-white/15 text-cream/70 hover:text-ink hover:bg-cream"
      : "border-black/10 text-ink/70 hover:text-white hover:bg-teal hover:border-teal";
  return (
    <div className={`flex gap-3 ${className}`} data-testid="social-links">
      {site.socials.map((s) => {
        const Icon = iconMap[s.icon];
        return (
          <a
            key={s.label}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${site.name} on ${s.label}`}
            data-testid={`social-${s.icon}`}
            className={`grid place-items-center h-10 w-10 rounded-full border transition-colors ${styles}`}
          >
            <Icon size={iconSize} />
          </a>
        );
      })}
    </div>
  );
};
